import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Popup, UiButton } from '@shared/ui';

import cls from './DocumentDownloadBlock.module.css';
import { useDocumentDownloadBlock } from './useDocumentDownloadBlock';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { DocumentSelect } from '../DocumentSelect/DocumentSelect';

interface DocumentDownloadBlockProps {
    classes?: string;
}

export const DocumentDownloadBlock = ({ classes }: DocumentDownloadBlockProps) => {
    const { onShowDocumentInfo, isShowPopup, onHidePopup, errorStatus, setErrorStatus } =
        useDocumentDownloadBlock();

    const { t } = useTranslation();

    return (
        <div className={classNames(cls.DocumentDownloadBlock, [classes])}>
            <Popup
                popupContentClassName={cls.popup}
                isOpen={isShowPopup}
                onHidePopup={onHidePopup}
                contentText=" "
            >
                <>
                    {t('DocumentDownloadBlock.return.popup.text.part1')}
                    <br />
                    {t('DocumentDownloadBlock.return.popup.text.part2')}
                </>
            </Popup>
            <div className={cls.DocumentSelectWrapper}>
                <DocumentSelect errorStatus={errorStatus} setErrorStatus={setErrorStatus} />
            </div>

            <UiButton
                className={cls.DownloadButton}
                onClick={onShowDocumentInfo}
                variant="icon"
                startIcon={<Icon iconName="downloadDocument" />}
            />
        </div>
    );
};
